import { ErrorPageNotFound } from '@jotta/ui/ErrorPageNotFound'
import { CookieDeclaration } from '@jotta/ui/CookieDeclaration'
import { useHasCookieConsentSupport } from '@jotta/ui/cookieConsent'

export function CookiesRoute() {
  const hasCookieConsentSupport = useHasCookieConsentSupport()
  return hasCookieConsentSupport ? <CookieDeclaration /> : <ErrorPageNotFound />
}
